import React from 'react';
import AssetConditionForm from '../../components/assetConditionComponents/AssetConditionForm';
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const AssetConditionFormPage = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Assets'));
    return <AssetConditionForm />
}

export default AssetConditionFormPage